export default __webpack_public_path__ + "static/solar-panel-icon-db42290fe247923b64516b64629d693e.webp";